export default {
  path: '/reservation',
  component: () => import('@/views/reservation/Index'),
  redirect: { name: 'reservation-hotels-list' },
  children: [
    {
      path: 'hotels',
      component: () => import('@/views/reservation/hotels/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/reservation/hotels/list/Layout'),
          children: [
            {
              path: '',
              name: 'reservation-hotels-list',
              component: () => import('@/views/reservation/hotels/list/Upcoming'),
              meta: {
                title: 'Hotel reservations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
            {
              path: 'archive',
              name: 'reservation-hotels-list-archive',
              component: () => import('@/views/reservation/hotels/list/Archive'),
              meta: {
                title: 'Hotel reservations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
            {
              path: 'cancelled',
              name: 'reservation-hotels-list-cancelled',
              component: () => import('@/views/reservation/hotels/list/Cancelled'),
              meta: {
                title: 'Hotel reservations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
            {
              path: 'in-house',
              name: 'reservation-hotels-list-in-house',
              component: () => import('@/views/reservation/hotels/list/InHouse'),
              meta: {
                title: 'Hotel reservations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            }
          ]
        },
        {
          path: ':id',
          component: () => import('@/views/reservation/hotels/detail/Layout'),
          children: [
            {
              path: '',
              name: 'reservation-hotels-general',
              component: () => import('@/views/reservation/hotels/detail/General'),
              meta: {
                title: 'Hotel reservations general',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'finance',
              name: 'reservation-hotels-finance',
              component: () => import('@/views/reservation/hotels/detail/Finance'),
              meta: {
                title: 'Hotel reservations finance',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'clients',
              name: 'reservation-hotels-clients',
              component: () => import('@/views/reservation/hotels/detail/Clients'),
              meta: {
                title: 'Hotel reservations clients',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'emails',
              name: 'reservation-hotels-emails',
              component: () => import('@/views/reservation/hotels/detail/Emails'),
              meta: {
                title: 'Hotel reservations emails',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              }
            },
            {
              path: 'history',
              name: 'reservation-hotels-history',
              component: () => import('@/views/reservation/hotels/detail/History'),
              meta: {
                title: 'Hotel reservations history',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              }
            },
          ],
        }
      ]
    },
    {
      path: 'meals',
      component: () => import('@/views/reservation/meals/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/reservation/meals/Layout'),
          children: [
            {
              path: '',
              name: 'reservation-meals-upcoming',
              component: () => import('@/views/reservation/meals/Upcoming'),
              meta: {
                title: 'Upcoming meals',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
            {
              path: 'archive',
              name: 'reservation-meals-archive',
              component: () => import('@/views/reservation/meals/Archive'),
              meta: {
                title: 'Archive meals',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
          ]
        },
        {
          path: ':id',
          component: () => import('@/views/reservation/meals/detail/Layout'),
          children: [
            {
              path: '',
              name: 'reservation-meal-general',
              component: () => import('@/views/reservation/meals/detail/General'),
              meta: {
                title: 'Meal reservations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              }
            },
            {
              path: 'finance',
              name: 'reservation-meal-finance',
              component: () => import('@/views/reservation/meals/detail/Finance'),
              meta: {
                title: 'Meal reservations finance',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'emails',
              name: 'reservation-meal-emails',
              component: () => import('@/views/reservation/meals/detail/Emails'),
              meta: {
                title: 'Emails meal reservations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              }
            },
            {
              path: 'history',
              name: 'reservation-meal-history',
              component: () => import('@/views/reservation/meals/detail/History'),
              meta: {
                title: 'History meal reservations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              }
            },
            {
              path: 'clients',
              name: 'reservation-meal-clients',
              component: () => import('@/views/reservation/meals/detail/Clients'),
              meta: {
                title: 'Clients meal reservations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              }
            },
          ]
        }
      ]
    },
    {
      path: 'bed-in-twin',
      component: () => import('@/views/reservation/bed-in-twin/Index'),
      children: [
        {
          path: '',
          name: 'reservation-bed-in-twin',
          component: () => import('@/views/reservation/bed-in-twin/List'),
          meta: {
            title: 'Bed in twin',
            roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
          },
        },
        {
          path: ':id',
          name: 'reservation-bed-in-twin-detail',
          component: () => import('@/views/reservation/bed-in-twin/Detail'),
          meta: {
            title: 'Bed in twin',
            roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
          },
        },
      ]
    },
    {
      path: 'cancellations',
      component: () => import('@/views/reservation/cancellation/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/reservation/cancellation/Layout'),
          children: [
            {
              path: '',
              name: 'reservation-hotels-cancellations-active',
              component: () => import('@/views/reservation/cancellation/Active'),
              meta: {
                title: 'Active cancellations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
            {
              path: 'cancelled',
              name: 'reservation-hotels-cancellations-cancelled',
              component: () => import('@/views/reservation/cancellation/Cancelled'),
              meta: {
                title: 'Cancelled cancellations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
            {
              path: 'stopped',
              name: 'reservation-hotels-cancellations-stopped',
              component: () => import('@/views/reservation/cancellation/Stopped'),
              meta: {
                title: 'Stopped cancellations',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
          ]
        }
      ]
    },
    {
      path: 'amendments',
      component: () => import('@/views/reservation/amendments/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/reservation/amendments/Layout'),
          children: [
            {
              path: '',
              name: 'reservation-hotels-amendments-pending',
              component: () => import('@/views/reservation/amendments/Pending'),
              meta: {
                title: 'Active amendments',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
            {
              path: 'completed',
              name: 'reservation-hotels-amendments-completed',
              component: () => import('@/views/reservation/amendments/Completed'),
              meta: {
                title: 'Cancelled amendments',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
            {
              path: 'stopped',
              name: 'reservation-hotels-amendments-stopped',
              component: () => import('@/views/reservation/amendments/Stopped'),
              meta: {
                title: 'Stopped amendments',
                roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager', 'sales_supervisor', 'support']
              },
            },
          ]
        }
      ]
    },
    {
      path: 'dashboard',
      name: 'reservation-dashboard',
      component: () => import('@/views/reservation/Dashboard'),
      meta: {
        title: 'Dashboard',
        roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant']
      },
    },
    {
      path: 'flights',
      component: () => import('@/views/reservation/flights/Index'),
      meta: { title: 'Flight reservations', roles: ['general_manager'] },
      children: [
        {
          path: '',
          component: () => import('@/views/reservation/flights/list/Layout'),
          meta: { title: 'Flight reservations', roles: ['general_manager'] },
          children: [
            {
              path: '',
              name: 'reservation-flights-list',
              component: () => import('@/views/reservation/flights/list/Active'),
              meta: {
                title: 'Flight reservations',
                roles: ['general_manager']
              },
            },
            {
              path: 'archive',
              name: 'reservation-flights-list-archive',
              component: () => import('@/views/reservation/flights/list/Archive'),
              meta: {
                title: 'Flight reservations',
                roles: ['general_manager']
              },
            },
            {
              path: 'cancelled',
              name: 'reservation-flights-list-cancelled',
              component: () => import('@/views/reservation/flights/list/Cancelled'),
              meta: {
                title: 'Flight reservations',
                roles: ['general_manager']
              },
            }
          ]
        },
        {
          path: ':id',
          component: () => import('@/views/reservation/flights/detail/Layout'),
          meta: { title: 'Flight reservation', roles: ['general_manager'] },
          children: [
            {
              path: '',
              name: 'reservation-flights-general',
              component: () => import('@/views/reservation/flights/detail/General'),
              meta: {
                title: 'Flight reservation',
                roles: ['general_manager']
              }
            },
            {
              path: 'finance',
              name: 'reservation-flights-finance',
              component: () => import('@/views/reservation/flights/detail/Finance'),
              meta: {
                title: 'Flight reservation finance',
                roles: ['general_manager']
              }
            },
            {
              path: 'finance-old',
              name: 'reservation-flights-finance-old',
              component: () => import('@/views/reservation/flights/detail/FinanceOld'),
              meta: {
                title: 'Flight reservation finance',
                roles: ['general_manager']
              }
            },
            {
              path: 'emails',
              name: 'reservation-flights-emails',
              component: () => import('@/views/reservation/flights/detail/Emails'),
              meta: {
                title: 'Flight reservation emails',
                roles: ['general_manager']
              }
            },
            {
              path: 'history',
              name: 'reservation-flights-history',
              component: () => import('@/views/reservation/flights/detail/History'),
              meta: {
                title: 'Flight reservation history',
                roles: ['general_manager']
              }
            },
          ],
        }
      ]
    },
    {
      path: 'payment-requests',
      component: () => import('@/views/reservation/payment-requests/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/reservation/payment-requests/Layout'),
          children: [
            {
              path: '',
              name: 'reservation-payment-requests',
              component: () => import('@/views/reservation/payment-requests/requests/List'),
              meta: {
                title: 'Payment requests',
                roles: ['general_manager', 'reservation_supervisor']
              },
            },
            {
              path: 'hotels',
              name: 'reservation-payment-requests-hotels',
              component: () => import('@/views/reservation/payment-requests/Hotels'),
              meta: {
                title: 'Payment requests hotels',
                roles: ['general_manager', 'reservation_supervisor']
              },
            },
            {
              path: 'flights',
              name: 'reservation-payment-requests-flights',
              component: () => import('@/views/reservation/payment-requests/Flights'),
              meta: {
                title: 'Payment requests flights',
                roles: ['general_manager', 'reservation_supervisor']
              },
            },
            {
              path: 'meals',
              name: 'reservation-payment-requests-meals',
              component: () => import('@/views/reservation/payment-requests/Meals'),
              meta: {
                title: 'Payment requests meals',
                roles: ['general_manager', 'reservation_supervisor']
              },
            },
            {
              path: 'analytics',
              name: 'reservation-payment-requests-analytics',
              component: () => import('@/views/reservation/payment-requests/Analytics'),
              meta: {
                title: 'Payment requests analytics',
                roles: ['general_manager', 'reservation_supervisor']
              },
            },
          ]
        },
        {
          path: ':id',
          name: 'reservation-payment-requests-detail',
          component: () => import('@/views/reservation/payment-requests/requests/Detail'),
          meta: {
            title: 'Payment requests',
            roles: ['general_manager', 'reservation_supervisor']
          },
        },
      ]
    },
    {
      path: 'safari',
      component: () => import('@/views/reservation/safari/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/reservation/safari/list/Layout'),
          children: [
            {
              path: '',
              name: 'reservation-safari-list',
              component: () => import('@/views/reservation/safari/list/Requests'),
              meta: {
                title: 'Safari reservations',
                roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
              },
            },
            {
              path: 'confirmed',
              name: 'reservation-safari-confirmed',
              component: () => import('@/views/reservation/safari/list/Confirmed'),
              meta: {
                title: 'Safari reservations',
                roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
              },
            },
          ]
        },
        {
          path: ':id',
          component: () => import('@/views/reservation/safari/detail/Layout'),
          children: [
            {
              path: '',
              name: 'reservation-safari-detail',
              component: () => import('@/views/reservation/safari/detail/General'),
              meta: {
                title: 'Safari',
                roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor', 'safari_manager']
              }
            },
            {
              path: 'finance',
              name: 'reservation-safari-detail-finance',
              component: () => import('@/views/reservation/safari/detail/Finance'),
              meta: {
                title: 'Finance',
                roles: ['general_manager', 'safari_supervisor']
              }
            },
            {
              path: 'available-cars',
              name: 'reservation-safari-detail-available-cars',
              component: () => import('@/views/reservation/safari/detail/AvailableCars'),
              meta: {
                title: 'Available Cars',
                roles: ['general_manager', 'safari_supervisor']
              }
            },
            {
              path: 'history',
              name: 'reservation-safari-detail-history',
              component: () => import('@/views/reservation/safari/detail/History'),
              meta: {
                title: 'History',
                roles: []
              }
            },
            {
              path: 'reservations',
              name: 'reservation-safari-detail-reservations',
              component: () => import('@/views/reservation/safari/detail/Reservations'),
              meta: {
                title: 'Reservations',
                roles: ['general_manager', 'safari_supervisor']
              }
            },
          ],
        }
      ]
    },
    {
      path: 'analytics',
      component: () => import('@/views/reservation/analytics/Layout.vue'),
      children: [
        {
          path: '',
          name: 'reservation-analytics',
          component: () => import('@/views/reservation/analytics/Bednight.vue'),
          meta: {
            title: 'Bednight',
            roles: ['general_manager']
          },
        },
      ]
    },
  ]
}
